<template>
  <div class="card-body mt-2 mb-2">
    <img src="@/assets/img/brand/logo.png" class=" d-lg-none header-brand-img text-left float-left mb-4" alt="logo">
    <div class="clearfix"></div>
    <ValidationObserver tag="form" ref="signInForm" action="" @submit.prevent="onSubmit()">
      <h5 class="text-left mb-2">{{$t('auth.signInAccount')}}</h5>
      <p class="mb-4 text-muted tx-13 ml-0 text-left">{{$t('auth.signInAccountInfo')}} </p>
      <ValidationProvider tag="div" v-slot="{ classes }" rules="required|email" class="form-group text-left">
        <label for="email">{{$t('auth.email')}}</label>
        <input id="email" v-model="loginFormData.email" :class="classes" type="email" name="email" class="form-control"
               :placeholder="$t('auth.enterEmail')"/>
      </ValidationProvider>
      <ValidationProvider tag="div" v-slot="{ classes }" rules="required" class="form-group text-left">
        <label for="password">{{$t('auth.password')}}</label>
        <input v-model="loginFormData.password" type="password" id="password" name="password" class="form-control"
               :class="classes" :placeholder="$t('auth.enterPassword')"/>
      </ValidationProvider>
      <button class="btn ripple btn-main-primary btn-block" :disabled="disabledSubmitBtn">{{$t('auth.signIn')}}</button>
      <small class="text-danger">{{errorMsg}}</small>
    </ValidationObserver>
    <div class="text-left mt-5 ml-0">
      <div class="mb-1">
        <router-link to="/auth/forgot-password">{{$t('auth.forgotPassword')}}?</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'SignIn',
  data () {
    return {
      loginFormData: {
        email: '',
        password: ''
      },
      disabledSubmitBtn: false,
      errorMsg: ''
    }
  },
  methods: {
    ...mapActions({
      login: 'auth/login'
    }),

    onSubmit () {
      this.$refs.signInForm.validate().then(success => {
        if (success) {
          this.errorMsg = ''
          this.login(this.loginFormData).then((res) => {
            if (res.success) {
              this.$router.push('/')
            } else {
              this.errorMsg = res.message
              return false
            }
          }).catch(err => {
            if (err.response.status === 422) {
              const data = err.response.data.errors
              const keys = Object.keys(data)
              const msg = data[keys[0]][0]
              this.$toasted.error(msg).goAway(1500)
            } else {
              this.errorMsg = err.response.data.message
              this.$toasted.error(err.response.data.message).goAway(1500)
            }
          }).finally(() => {
            this.disabledSubmitBtn = false
          })
        }
      })
    }
  }
}
</script>
